import { adaptDatabaseFieldFunction } from '@/modules/corporate/modules/database/fields/types';
import { DatabaseTextFormatEnum } from '@/types/schema';

export const adaptTextField: adaptDatabaseFieldFunction = ({ metadataField, viewField }) => ({
  metadataField,
  viewField: { ...viewField, textType: viewField.textType || DatabaseTextFormatEnum.SingleLine },
});
